(() => {
  const SELECTOR = '[data-mystery-photo-slider]';

  function setupSlider(section) {
    if (!section || section.dataset.mysteryInitialized === 'true') return;

    const track = section.querySelector('[data-mystery-track]');
    const group = section.querySelector('[data-mystery-group]');

    if (!track || !group) return;

    track
      .querySelectorAll('[data-mystery-clone="true"]')
      .forEach((node) => node.remove());

    const clone = group.cloneNode(true);

    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-mystery-clone', 'true');

    clone.querySelectorAll('[id]').forEach((el) => {
      el.removeAttribute('id');
    });

    clone
      .querySelectorAll('[data-shopify-editor-block]')
      .forEach((el) => {
        el.removeAttribute('data-shopify-editor-block');
      });

    track.appendChild(clone);

    const speed = Number(section.dataset.speed || 55);

    track.style.setProperty(
      '--mystery-duration',
      `${speed}s`
    );

    section.dataset.mysteryInitialized = 'true';
  }

  function initAll(root = document) {
    root
      .querySelectorAll(SELECTOR)
      .forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:reorder',
    () => {
      initAll();
    }
  );
})();